import { InviteSendOutcomeKind } from '../invitation.const'
import type { InvitationOperationResult } from '../invitation.interface'
import { InvitationOperationCategory } from '../invitation.interface'
import { classifyInvitationOperation } from '../mappers/classifyInvitationOperation'
import { mapInvitationOutcomeToMessage } from '../mappers/mapInvitationOutcomeToMessage'

export type { InviteSendOutcomeKind } from '../invitation.const'

export function resolveInviteSendOutcome(result: InvitationOperationResult): {
  kind: InviteSendOutcomeKind
  message: string
} {
  const message = mapInvitationOutcomeToMessage(result)

  switch (classifyInvitationOperation(result.outcome)) {
    case InvitationOperationCategory.SendSuccess:
      return { kind: InviteSendOutcomeKind.Success, message }
    case InvitationOperationCategory.SendInformational:
      return { kind: InviteSendOutcomeKind.Informational, message }
    case InvitationOperationCategory.SendConflict:
      return { kind: InviteSendOutcomeKind.Conflict, message }
    default:
      return {
        kind: result.succeeded ? InviteSendOutcomeKind.Success : InviteSendOutcomeKind.Failure,
        message,
      }
  }
}
